import React from "react";
import { Modal } from "antd";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useStore } from "../../_Store";
import { addNewFarm, updateFarm } from "hooks/useFarmData";
import { useNavigate } from "react-router-dom";
import { getUserProfile } from "../../services/auth.service";
import { Store } from "../../components/Ui";
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
const initialValues = {
  farmName: "",
  isRegistered: "",
  latitude: "",
  areaLabel: '',
  area: '',
  longitude: "",
  landTitleNumber: "",
};
const FarmPoints = ({ visible, row, onSuccess, onCancel }) => {

  const {
    setUserProfile
  } = React.useContext(Store);

  const getLoginUserDetails = async () => {
    const res = await getUserProfile();
    if (res.data.success) {
      setUserProfile(res.data.data);
      setTimeout(function () {
        navigate('/farms', { replace: true });
      }, 1000)
    }
  }
  function handleClick() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          formik.setFieldValue('latitude', position.coords.latitude);
          formik.setFieldValue('longitude', position.coords.longitude);
        },
        (error) => {
          console.error(error);
        }
      );
    } else {
      console.error('Geolocation is not supported by this browser.');
    }
  }
  // console.log(row)
  const navigate = useNavigate();
  const {
    setUtils,
  } = useStore();
  const [m, setMethod] = React.useState("");
  const [title, setTitle] = React.useState("");
  const { mutate: addFarm } = addNewFarm();
  const { mutate: update } = updateFarm();
  React.useEffect(() => {
    if (row && row.id) {
      setTitle("Modifier Champs");
      setMethod("put");

      formik.setValues({
        ...initialValues,
        ...{
          farmName: row.farmName,
          isRegistered: row.isRegistered,
          latitude: row.latitude,
          area: row.area,
          longitude: row.longitude,
          landTitleNumber: row.landTitleNumber,
        },
      });
    } else {
      setTitle("Ajoutez une Champs");
      setMethod("post");
    }

    return () => {
      formik.resetForm();
    }
  }, [row, visible]);

  const close = () => {
    formik.resetForm();
    onCancel();
  };

  const validationSchema = yup.object({
    isRegistered: yup.string(),
    landTitleNumber: yup.string().when("isRegistered", {
      is: 'true',
      then: yup.string().required("Non valide, réessayer").trim("Entrer une latitude valide."),
    }),
    farmName: yup.string().required("Ce champ est obligatoire.").trim("Entrez un nom valide."),
    areaLabel: yup.string().required("Ce champ est obligatoire."),
    area: yup.number().required("Ce champ est obligatoire."),
    latitude: yup
      .number("La valeur de la latitude doit être un nombre")
      .required("Ce champ est obligatoire."),
    longitude: yup
      .number("La valeur de la longitude doit être un nombre")
      .required("Ce champ est obligatoire."),
  });
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (v) => {
      console.log('Golem23');
      v.area = v.areaLabel == 'h' ? v.area : (v.area * 0.0001)
      if (m === 'post') {
        addFarm(v, {
          onSuccess: async (response) => {
            if (response.data.success) {
              close();
              onSuccess(m, v);
              getLoginUserDetails();
              setUtils("loading", { spinning: false, primary: "" });
            } else {
              setUtils("loading", { spinning: false, primary: "" });
            }
          },
        });
      } else {
        update({ ...v, farmId: row.id }, {
          onSuccess: (response) => {
            if (response.success) {
              close();
              onSuccess(m, v);
              setUtils("loading", { spinning: false, primary: "" });
            } else {
              setUtils("loading", { spinning: false, primary: "" });
            }
          },
        })
      }
    },
  });


  return (
    <React.Fragment>
      <Modal
        visible={visible}
        open={visible}
        width={500}
        title={title}
        centered
        footer={null}
        onCancel={close}
      >
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-4">
            <FormControl fullWidth>
              <TextField
                name="farmName"
                label="Nommez l'expoitation agricole"
                value={formik.values.farmName.trimStart()}
                error={formik.touched.farmName && Boolean(formik.errors.farmName)}
                helperText={formik.touched.farmName && formik.errors.farmName}
                onChange={formik.handleChange}
              />
            </FormControl>
          </div>
          <div className="mb-4">
            <FormControl
              fullWidth
              error={formik.touched.areaLabel && Boolean(formik.errors.areaLabel)}
            >
              <InputLabel>Superficie de la ferme en</InputLabel>
              <Select
                name="areaLabel"
                label="Mètres carrés ou Hectares"
                value={formik.values.areaLabel}
                onChange={formik.handleChange}
              >
                {[{ label: 'Mètre carré', value: 'm2' },
                { label: 'Hectare', value: 'h' }].map((opt, id) => (
                  <MenuItem key={id} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>
                {formik.touched.areaLabel && formik.errors.areaLabel}
              </FormHelperText>
            </FormControl>
          </div>
          <div className="mb-4">
            <FormControl fullWidth>
              <TextField
                name="area"
                label="Superficie de la ferme"
                type={"number"}
                value={formik.values.area}
                error={formik.touched.area && Boolean(formik.errors.area)}
                helperText={formik.touched.area && formik.errors.area}
                onChange={formik.handleChange}
              />
            </FormControl>
          </div>
          <div className="mb-4">
            <FormControl
              fullWidth
              error={formik.touched.isRegistered && Boolean(formik.errors.isRegistered)}
            >
              <InputLabel>Inscription de la terre</InputLabel>
              <Select
                name="isRegistered"
                label="Inscription de la terre"
                value={formik.values.isRegistered}
                onChange={formik.handleChange}
              >
                {[{ label: 'Enrégistrée', value: 'true' }, { label: 'Non enrégistrée', value: 'false' }].map((opt, id) => (
                  <MenuItem key={id} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>
                {formik.touched.isRegistered && formik.errors.isRegistered}
              </FormHelperText>
            </FormControl>
          </div>

          {formik.values.isRegistered === 'true' ? (
            <div className="mb-4">
              <FormControl fullWidth>
                <TextField
                  name="landTitleNumber"
                  label="Numéro du titre foncier"
                  value={formik.values.landTitleNumber.trimStart()}
                  error={formik.touched.landTitleNumber && Boolean(formik.errors.landTitleNumber)}
                  helperText={formik.touched.landTitleNumber && formik.errors.landTitleNumber}
                  onChange={formik.handleChange}
                />
              </FormControl>
            </div>
          ) : null}
        
          <div className="mb-4">
            <button onClick={handleClick} type={"button"} style={{ color:"darkgreen" }}> <GpsFixedIcon/> Obtenir mes coordonnées actuelles</button>
          </div>
          <div className="mb-4">
            <FormControl fullWidth>
              <TextField
                name="latitude"
                label="Latitude"
                type="number"
                value={formik.values.latitude}
                error={
                  formik.touched.latitude && Boolean(formik.errors.latitude)
                }
                helperText={formik.touched.latitude && formik.errors.latitude}
                onChange={formik.handleChange}
              />
            </FormControl>
          </div>
          <div className="mb-4">
            <FormControl fullWidth>
              <TextField
                name="longitude"
                label="Longitude"
                type="number"
                value={formik.values.longitude}
                error={
                  formik.touched.longitude && Boolean(formik.errors.longitude)
                }
                helperText={formik.touched.longitude && formik.errors.longitude}
                onChange={formik.handleChange}
              />
            </FormControl>
          </div>

          <p className="mt-4">&nbsp;</p>
          <div className="flex justify-between">
            <Button
              size="large"
              variant="outlined"
              disableElevation
              color="secondary"
              onClick={close}
            >
              Annuler
            </Button>
            <Button
              size="large"
              variant="outlined"
              disableElevation
              color="success"
              type="submit"
            >
              {m === "post" ? "Ajouter" : "Modifier"}
            </Button>
          </div>
        </form>
      </Modal>
    </React.Fragment>
  );
};

export default FarmPoints;
